import { useTranslation } from 'react-i18next';

const useMessageHook = () => {
    const { t } = useTranslation('common');

    const requiredMsg = (name) => {
        return t(`form.required`).replace('{name}', t(`form.${name}`));
    };
    const requireSelectMsg = (name) => {
        return t(`form.required_select`).replace('{name}', t(`form.${name}`));
    };
    const requiredCheckboxMsg = (name) => {
        return t(`form.required_checkbox`).replace('{name}', t(`form.${name}`));
    };
    const requireUpload = (name) => {
        return t(`form.upload_required`).replace('{name}', t(`form.${name}`));
    };

    const minMsg = (name, min) => {
        return t('form.min')
            .replace('{name}', t(`form.${name}`))
            .replace('{min}', min);
    };

    const maxMsg = (name, max) => {
        return t('form.max')
            .replace('{name}', t(`form.${name}`))
            .replace('{max}', max);
    };

    const emailMsg = (name) => {
        return t(`form.email_type`).replace('{name}', t(`form.${name}`));
    };

    const regexMessage = (name) => {
        return t(`form.regex_type`).replace('{name}', t(`form.${name}`));
    };

    const equalMessage = (name, equal) => {
        return t(`form.equal_type`)
            .replace('{name}', t(`form.${name}`))
            .replace('{equal}', t(`form.${equal}`));
    };

    const numberMsg = (name) => {
        return t(`form.number_type`).replace('{name}', t(`form.${name}`));
    };

    return {
        requiredMsg,
        requireSelectMsg,
        requiredCheckboxMsg,
        requireUpload,
        minMsg,
        maxMsg,
        emailMsg,
        regexMessage,
        equalMessage,
        numberMsg,
    };
};

export default useMessageHook;
